import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { useCallback, useMemo, useState } from 'react';
import { Element } from 'react-scroll';
import { isNullOrUndefinedOrEmpty } from '../../../../../helpers/common';
import { propFunc, propArrayShape, propOneOf, } from '../../../../../helpers/custom-prop-types';
import ProfessionalUnitFilterSelect from '../../Parts/ProfessionalUnitFilterSelect';
import ProfessionalUnitItemsList from '../../Parts/ProfessionalUnitItemsList';
import ProfessionalUnitSectionTitle from '../../Parts/ProfessionalUnitSectionTitle';
import ProfessionalUnitProjectCareerWrapper from './ProfessionalUnitProjectCareerWrapper';
const ProfessionalUnitProjectCareers = (props) => {
    const { onClickReadMore, projectCareers: rawProjectCareers, showAlertModal, userMode, } = props;
    const [filter, changeFilter] = useState('');
    const options = useMemo(() => {
        const values = _(rawProjectCareers)
            .map((v) => _.get(v, 'middleTasks'))
            .flatten()
            .value();
        return _.uniqBy(values, 'id').map((v) => ({
            color: '#485C60',
            id: v.id,
            label: v.name,
            value: v.id,
        }));
    }, [rawProjectCareers]);
    /**
     * フィルター変更
     * @type {(function({value?: *}): void)|*}
     */
    const onChangeFilter = useCallback(({ value }) => {
        changeFilter(value ? parseInt(value, 10) : null);
    }, [changeFilter]);
    const items = useMemo(() => rawProjectCareers.filter((projectCareer) => isNullOrUndefinedOrEmpty(filter)
        ? true
        : projectCareer.middleTasks.some((v) => v.id === filter)), [filter, rawProjectCareers]);
    if (!rawProjectCareers.length) {
        return null;
    }
    return (_jsxs("section", Object.assign({ className: 'unit_project_careers' }, { children: [_jsx(Element, { name: 'section_project_careers' }), _jsx(ProfessionalUnitSectionTitle, { count: rawProjectCareers.length, title: 'プロジェクト実績', unit: '件' }), _jsx(ProfessionalUnitFilterSelect, { name: 'project_career_filter', onChange: onChangeFilter, options: options, placeholder: 'カテゴリーで絞り込む', userMode: userMode }), _jsx(ProfessionalUnitItemsList, { className: 'project_career_items', guestMoreText: 'プロジェクト実績をすべて見る（会員登録）', items: items, renderComponent: _jsx(ProfessionalUnitProjectCareerWrapper, { onClickReadMore: onClickReadMore, showAlertModal: showAlertModal, userMode: userMode }), showAlertModal: showAlertModal, userMode: userMode })] })));
};
ProfessionalUnitProjectCareers.propTypes = {
    onClickReadMore: propFunc().isRequired,
    projectCareers: propArrayShape().isRequired,
    showAlertModal: propFunc().isRequired,
    userMode: propOneOf(['view', 'guest', 'other', 'pre']).isRequired,
};
export default ProfessionalUnitProjectCareers;
